<template>
    <div class="study">
        <div
            class="tips"
            v-if="content.isPunch === 'Y' && content.nextPage === 'N' && content.examinationPrompt"
        >
            {{ content.examinationPrompt }}
        </div>
        <div
            class="tips2"
            v-if="content.isPunch === 'Y' && content.nextPage === 'N' && content.examinationPrompt"
        >
            {{ content.examinationPrompt }}
        </div>
        <div class="classTitle" v-if="content.learningName">
            {{ content.learningName }}
        </div>
        <div class="learningName" v-if="content.learningTitle">
            {{ content.learningTitle }}
        </div>
        <div
            class="learningContent"
            v-if="content.learningContent"
            v-html="content.learningContent"
        ></div>
        <template v-if="content.questions">
            <div v-for="question in content.questions" :key="question.id">
                <div class="studyNoteTitle" :class="{'required_icon': question.isRequired == 'Y'}">
                    {{question.question}}
                </div>
                <div class="note_box">
                    <van-field
                        rows="6"
                        class="note"
                        :readonly="
                            type === 'item' && content.isPunch === 'Y' ? true : false
                        "
                        v-model="question.elpLearningItemQuestionAnswer.answer"
                        type="textarea"
                        @input="cacheNote(question)"
                        show-word-limit
                        :placeholder="question.defaultValue ? question.defaultValue : '选填，请输入学习笔记'"
                    />
                </div>
            </div>
            
        </template>
        <!-- <div class="studyNoteTitle" v-if="content.learningContent">
            请为本条内容进行评分（0-100分）
        </div>
         <div class="note_box">
            <van-field
                v-if="content.learningContent"
                class="note"
                :readonly="
                    type === 'item' && content.isPunch === 'Y' ? true : false
                "
                v-model="fraction"
                placeholder="请输入评分（0-100分）"
            />
        </div> -->
        <div class="btn_box" v-if="content.learningContent">
            <van-button class="home" @click="goHome" type="primary"
                >首页</van-button
            >
            <van-button
                v-if="type === 'item' && content.isPunch === 'Y'"
                @click="goPage(content, 'pre')"
                class="pre"
                type="primary"
                >上一个</van-button
            >
            <van-button
                v-if="type === 'item' && content.isPunch === 'Y'"
                @click="goPage(content, 'next')"
                class="next"
                type="primary"
                >下一个</van-button
            >
            <van-button
                v-if="
                    type === 'item' &&
                    content.isPunch === 'Y' &&
                    content.isExamination === 'N' &&
                    content.nextPage === 'N' &&
                    content.examinationPrompt === '已完成该学习计划中的全部内容，请点击底部按钮进行考试'
                "
                class="examination"
                @click="goExamination(content.learningId)"
                type="primary"
                >立即考试</van-button
            >
            <van-button
                v-if="content.isPunch === 'N'"
                class="punch"
                @click="punch"
                type="primary"
                >已完成学习，提交打卡</van-button
            >
        </div>
    </div>
</template>
<script>
import {
    elpUserLearningPlanItemFindById,
    elpUserPunch,
    elpUserLearningPlanItemPage,
    saveElpUserPunchSessionNoteApi,
    findElpLearningDurationApi,
    elpLearningDurationOnMessageApi
} from "@/common/api";
import watermark from "watermark-dom";
import { ImagePreview } from "vant";
export default {
    data() {
        return {
            socket: null,
            content: {},
            // note: "",
            fraction: "",
            type: "",
            timer: null,
            elpUserPunchSessionNoteId: "",
            interval: 0,
            oldcurrentTimes: 0,
            currentTimes: 0,
            duration: 0,
            elpUserLearningPlanItemId: '',
        };
    },
    async mounted() {
        const currentUser =
            JSON.parse(localStorage.getItem("currentUser")) || undefined;
        watermark.init({
            watermark_txt: currentUser.name,
            watermark_angle: 30,
        });
        let id = this.$route.params.id;
        this.type = this.$route.params.type;
        if (this.$route.params.type === "class") {
            let response = await elpUserLearningPlanItemFindById({ id });
            if (response.success) {
                this.content = { ...response.data.data };
                // this.note = response.data.data.note;
                // this.fraction = response.data.data.fraction;
            }
        } else if (this.$route.params.type === "item") {
            let response = await elpUserLearningPlanItemPage({ id, type: "2" });
            if (response.success) {
                this.content = { ...response.data };
                // this.note = response.data.note;
                // this.fraction = response.data.fraction;
            }
        }
        this.$nextTick(async () => {
            try {
                // 图片预览
                let imgs = document.querySelectorAll("img");
                imgs.forEach((item) => {
                    item.addEventListener("click", (e) => {
                        ImagePreview([e?.target?.src]);
                    });
                });
                this.watchVideo();
            } catch (error) {
                console.log("error",error)
            }
        });
    },
    beforeUnmount(){
        console.log('关闭了')
        this.socket?.close();
    },
    methods: {
        async watchVideo(){
            try {
                const _self = this;
                const videos = document.querySelectorAll('.learningContent video');
                const currentUser = localStorage.getItem('currentUser');
                if(currentUser && currentUser != ''){
                    const userId = JSON.parse(currentUser)?.userId ?? '';
                    if(videos.length > 0){
                        // if('WebSocket' in window){
                            const v1 = videos[0];  
                            const socketFn = ()=>{
                                // _self.socket = new WebSocket(`wss://${location.hostname}/study/websocket/${userId}`);
                                // _self.socket.onopen = function() {
                                    v1.addEventListener('timeupdate',function(e){
                                        // _self.socket.send(JSON.stringify({
                                        //     currentTimes: e.target.currentTime,
                                        //     duration: e.target.duration,
                                        //     elpUserLearningPlanItemId: _self.content.id
                                        // })); // 发送消息到服务器
                                        console.log(e)
                                        _self.currentTimes = e.target.currentTime;
                                        _self.duration = e.target.duration;
                                        _self.elpUserLearningPlanItemId = _self.content.id;
                                        if(e.target.currentTime == e.target.duration){
                                            _self.oldcurrentTimes = _self.currentTimes;
                                            elpLearningDurationOnMessageApi(userId,{
                                                currentTimes: _self.currentTimes,
                                                duration: _self.duration,
                                                elpUserLearningPlanItemId: _self.elpUserLearningPlanItemId
                                            });
                                        }
                                    });
                                    clearInterval(_self.interval);
                                    _self.interval = setInterval(async () => {
                                        if(_self.oldcurrentTimes != _self.currentTimes){
                                            _self.oldcurrentTimes = _self.currentTimes;
                                            elpLearningDurationOnMessageApi(userId,{
                                                currentTimes: _self.currentTimes,
                                                duration: _self.duration,
                                                elpUserLearningPlanItemId: _self.elpUserLearningPlanItemId
                                            });
                                        }
                                    }, 5000);

                                // };
                                // _self.socket.onclose = function(event){
                                //     console.log('断线重连中,',event);
                                //     socketFn();
                                // }
                                // _self.socket.onerror = function(event){
                                //     console.log("error",event);
                                // };
                            }
                            v1.style.width = '100%';
                            // 设置初始播放速度
                            v1.playbackRate = 1.0;
                            // 监听播放速度变化事件
                            // v1.addEventListener('ratechange', function() {
                            //     // 将播放速度重置为初始值
                            //     v1.playbackRate = 1.0;
                            // });
                            socketFn();
                            findElpLearningDurationApi({id:_self.content.id,userId }).then(res=>{
                                if(res.success && res.data){
                                    const v1 = videos[0]; 
                                    v1.currentTime = res.data.currentTimes;
                                }
                            });
                        // }else{
                        //     console.log("不支持socket");
                        //     await this.$dialog.alert({
                        //         title: "温馨提示",
                        //         confirmButtonText: '关闭',
                        //         message: "请在手机微信打开链接或电脑谷歌浏览器中观看视频",
                        //     });
                        // }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 返回首页
        goHome() {
            this.$router.back();
        },
        // 翻页
        async goPage(item, type) {
            switch (type) {
                case "pre":
                    if (item.previousPage === "N") {
                        this.$toast.fail("已是第一个");
                        return;
                    } else if (item.previousPage === "Y") {
                        let id = this.content.id;
                        let res = await elpUserLearningPlanItemPage({
                            id,
                            type: "0",
                        });
                        if (res.success) {
                            this.content = { ...res.data };
                            // this.note = res.data.note;
                            // this.fraction = res.data.fraction;
                            this.$nextTick(()=>{
                                this.watchVideo();
                            });
                        }
                    }
                    this.$nextTick(function () {
                        scrollTo(0, 0);
                        watermark.remove();
                        const currentUser =
                            JSON.parse(localStorage.getItem("currentUser")) ||
                            undefined;
                        watermark.init({
                            watermark_txt: currentUser.name,
                            watermark_angle: 30,
                        });
                    });
                    break;
                case "next":
                    if (item.nextPage === "N") {
                        this.$toast.fail("已是最后一个");
                        return;
                    } else if (item.nextPage === "Y") {
                        let id = this?.content?.id;
                        let res = await elpUserLearningPlanItemPage({
                            id,
                            type: "1",
                        });
                        if (res.success) {
                            this.content = { ...res.data };
                            // this.note = res.data.note;
                            // this.fraction = res.data.fraction;
                            this.$nextTick(()=>{
                                this.watchVideo();
                            });
                        }
                    }
                    this.$nextTick(function () {
                        scrollTo(0, 0);
                        watermark.remove();
                        const currentUser =
                            JSON.parse(localStorage.getItem("currentUser")) ||
                            undefined;
                        watermark.init({
                            watermark_txt: currentUser.name,
                            watermark_angle: 30,
                        });
                    });
                    break;
            }
        },
        // 学习打卡
        async punch() {
            let elpLearningItemQuestionAnswerList = [];
            if(this.content.questions){
                elpLearningItemQuestionAnswerList.push(...this.content.questions.map(x=>{
                    return {
                        id: x.elpLearningItemQuestionAnswer?.id ?? '',
                        elpLearningItemQuestionId: x.id,
                        elpLearningItemQuestion: x.question,
                        answer: x.elpLearningItemQuestionAnswer?.answer ?? '',
                        isRequired: x.isRequired
                    }
                }))
                // 校验必填项
                if(elpLearningItemQuestionAnswerList.some(x=>x.isRequired == 'Y' && x.answer == '')){
                    this.$toast.fail("请输入必填项");
                    return
                }
            }
            
            // if(elpLearningItemQuestionAnswerList.some(x=>!x.answer || x.answer == '')){
            //     let row = elpLearningItemQuestionAnswerList.filter(x=>!x.answer || x.answer == '')[0];
            //     this.$toast.fail("请输入" + row.elpLearningItemQuestion + '的答案');
            //     return
            // }
            // if(this.content.learningContent && (this.fraction.trim() == '' || Number.isNaN(Number(this.fraction)) || Number(this.fraction) < 0 || Number(this.fraction) > 100)){
            //     this.$toast.fail("请输入0-100的数字进行评分")
            //     return
            // }
            let params = {
                learningItemId: this.content.id,
                // note: this.note,
                elpLearningItemQuestionAnswerList,
                // fraction: this.fraction,
            };
            let response = await elpUserPunch(params);
            if (response?.success) {
                this.$toast.success(response?.msg);
                if (this.content.nextPage === "Y") {
                    let id = this?.content?.id;
                    let res = await elpUserLearningPlanItemPage({
                        id,
                        type: "1",
                    });
                    if (res.success) {
                        this.content = { ...res.data };
                        // this.note = res.data.note;
                        // this.fraction = res.data.fraction;
                        this.$nextTick(()=>{
                            this.watchVideo();
                        });
                    }
                    this.$nextTick(function () {
                        scrollTo(0, 0);
                        watermark.remove();
                        const currentUser =
                            JSON.parse(localStorage.getItem("currentUser")) ||
                            undefined;
                        watermark.init({
                            watermark_txt: currentUser.name,
                            watermark_angle: 30,
                        });
                    });
                } else if (
                    this.content.nextPage === "N" &&
                    this.content.isExamination === "N"
                ) {
                    if(response.data === false){
                        this.$toast.success('已完成当前学习计划的全部内容');
                        setTimeout(() => {
                            location.href = location.protocol + '//' + location.host + '/#/home'
                        }, 1000);
                    }else{
                        try {
                            await this.$dialog.confirm({
                                title: "温馨提示",
                                confirmButtonText: "立即考试",
                                cancelButtonText: "返回首页",
                                message: "已完成当前学习计划的全部内容",
                            });
                            this.goExamination(this.content.learningId);
                        } catch (error) {
                            this.$router.back();
                        }
                    }
                   
                }
            }
        },
        // 立即考试
        goExamination(id) {
            this.$router.push(`/examination/${id}/item`);
        },
        // 缓存学习笔记
        async cacheNote(questionObj) {
            try {
                if (this.timer != null) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(async () => {
                    let { learningId, id } =
                        this.content;
                    const res = await saveElpUserPunchSessionNoteApi({
                        // note: e.target.value,
                        elpLearningItemQuestionId: questionObj.id,
                        elpLearningItemQuestion: questionObj.question,
                        answer: questionObj.elpLearningItemQuestionAnswer?.answer ?? '',
                        learningId,
                        learningItemId: id,
                        id: questionObj.elpLearningItemQuestionAnswer?.id ?? '',
                    });
                    if (res.success) {
                        questionObj.elpLearningItemQuestionAnswer.id = res.msg;
                    }
                }, 800);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.study {
    background: white;
    min-height: 100vh;
    padding-bottom: 100px;
    .tips {
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 1000;
        background: var(--theme-yellow-color);
        color: white;
        padding: 15px;
        font-size: 14px;
        box-sizing: border-box;
    }
    .tips2 {
        width: 100%;
        background: none;
        color: white;
        padding: 15px;
        font-size: 14px;
        box-sizing: border-box;
    }
    .classTitle {
        font-size: 14px;
        color: var(--theme-vice-font-color);
        padding: 15px;
    }
    .learningName {
        font-size: 16px;
        color: var(--theme-font-color);
        margin: 10px 0px;
        padding: 0 15px;
        font-weight: 600;
    }
    .learningContent {
        color: var(--theme-font-color);
        border-top: 1px solid #f7f7f7;
        border-bottom: 1px solid #f7f7f7;
        padding: 10px 15px;
        /deep/ img {
            max-width: 100%;
        }
        /deep/ video {
            max-width: 100%;
        }
    }
    .studyNoteTitle {
        font-size: 16px;
        color: var(--theme-font-color);
        margin: 10px 0px;
        font-weight: 600;
        padding: 0 15px;
        padding-left: 20px;
    }
    .required_icon::before{
        content: '*';
        width: 12px;
        height: 12px;
        color: red;
        position: absolute;
        transform: translateX(-10px);
    }
    .note_box {
        padding: 0px 15px;
        .note {
            font-size: 14px;
            background: #f7f7f7;
            border-radius: 8px;
        }
    }
    .btn_box {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        z-index: 1000;
        display: flex;
        padding: 15px;
        background: #f5f5f5;
        .home {
            flex: 2;
            background: #b3b3b3;
            border-color: #b3b3b3;
            margin-right: 5px;
        }
        .pre {
            flex: 2;
            background: #b3b3b3;
            border-color: #b3b3b3;
            margin-right: 5px;
        }
        .next {
            flex: 2;
            background: #b3b3b3;
            border-color: #b3b3b3;
        }
        .punch {
            flex: 4;
            background: var(--van-primary-color);
            margin-left: 5px;
        }
        .examination {
            flex: 3;
            background: var(--van-primary-color);
            margin-left: 5px;
        }
    }
}
</style>
